import React from 'react';
import {Table } from 'antd';

function Tabelhistory(props) {
    const data=props.userInfo
    const columns = [
        {
            title: "O'quv yili",
            render: edu => <span>{edu?.education_year_info?.name}</span>,
        },
        {
            title: 'Kurs',
            render: edu => <span>{edu?.levelInfo?.name}</span>,
        },
        {
            title: 'Telefon',
            dataIndex:'phone'
        },
        {
            title: 'Arizaning holati',
            render: edu => <div><p style={{border:"none", borderRadius:"4px",backgroundColor:"orange",color:"#00000", padding:"4px 2px", width:"30%", textAlign:"center"}}>{edu?.applicationStatus === "PENDING" ? "Jarayonda" : ""}</p></div>
        },
        {
            title: 'GPA',
            render: edu => <span>{edu?.student?.avg_gpa === null ? "yo‘q" : edu?.student?.avg_gpa}</span>
        },
        {
            title: 'Akademik o\'zlashtirish ko\'rsatkichi',
            render: edu => <span>{edu?.academicRating === null ? "yo‘q" : edu?.academicRating}</span>
        },
        {
            title: 'Ijtimoiy faollik ball',
            render: edu => <span>{edu?.departmentRating === null ? "yo‘q" : edu?.departmentRating}</span>,
        },
        {
            title: 'Umumiy ball',
            render: edu =>
                <span>{edu?.academicAndDepartmentRating === null ? "yo‘q" : edu?.academicAndDepartmentRating}</span>
        },

    ];

    return (
        <>
            <h4 className='mt-3'>Ta'lim grantiga arizalar tarixi</h4>
        <Table columns={columns}  dataSource={data?.map(item => {
            return {...item, key: item.id}
        })}/>
        </>
    );
}

export default Tabelhistory;